<template>
  <div class="box-border p-0 mb-2 mx-auto">
    <div class="flex flex-wrap">
      <label for="cbox1" class="block text-center w-80 py-1 px-3 mx-auto text-lg
            font-medium text-[--color-orange] cursor-pointer" @click.prevent="toggleShowCalendar">
        <font-awesome-icon icon="fa-calendar" />
        {{ formattedStartDate ?? $t("KssRuntimeComponent.selectDate") }}
      </label>
      <div class="order-last flex-grow w-full" id="div_calendar-date" v-if="getShowCalendar">
        <edit-kss-calendar-component
          :editable="true"
          :initialDate="selectedDate"
          @updateDate="updateSelectedDate"
        />
      </div>
      <label for="cbox2" class="block text-center w-80 py-1 px-3 mx-auto text-lg
            font-medium text-[--color-orange] cursor-pointer" @click.prevent="toggleShowRuntime">
        <font-awesome-icon icon="fa-clock" />
        {{ formattedTime ?? $t("KssRuntimeComponent.selectRuntime") }}
      </label>
      <div class="order-last flex-grow w-full" id="div_calendar-time" v-if="getShowRuntime">
        <!----------------- RUNTIME ----------------->
        <div class="mt-4 rounded-lg bg-white p-8 border border-[#e2e8f0]">
          <edit-kss-runtime-component
            :editable="true"
            :initialDate="getRuntimeDate"
            @updateTime="updateSelectedTime"
            :is-start-time="isStartTime"
            :hideRecurring="hideRecurring"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditKssCalendarComponent from '@/components/Home/KssCreator/KssEditComponents/EditKssCalendarComponent.vue';
import EditKssRuntimeComponent from '@/components/Home/KssCreator/KssEditComponents/EditKssRuntimeComponent.vue';

export default {
  name: 'DateTimeSelectionComponent',
  components: {
    EditKssRuntimeComponent,
    EditKssCalendarComponent,
  },
  props: {
    modelValue: Date,
    isStartTime: Boolean,
    hideRecurring: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showRuntime: false,
      showCalendar: false,
      selectedHours: null,
      selectedMinutes: null,
      selectedDate: this.modelValue,
    };
  },
  computed: {
    formattedStartDate() {
      if (!this.selectedDate) {
        return '';
      }
      return `${`0${this.selectedDate.getDate()}`.slice(-2)}.${`0${
        this.selectedDate.getMonth() + 1
      }`.slice(-2)}.${this.selectedDate.getFullYear()}`;
    },
    formattedTime() {
      return `${`0${this.selectedHours}`.slice(-2)}:${`0${this.selectedMinutes}`.slice(-2)}`;
    },
    getRuntimeDate() {
      return new Date(
        this.selectedDate.getFullYear(),
        this.selectedDate.getMonth(),
        this.selectedDate.getDate(),
        this.selectedHours,
        this.selectedMinutes,
      );
    },
    getShowCalendar() {
      return this.showCalendar;
    },
    getShowRuntime() {
      return this.showRuntime;
    },
  },
  methods: {
    updateSelectedDate(date) {
      this.selectedDate = date;
      this.$emit('update:modelValue', this.getRuntimeDate);
    },
    updateSelectedTime(time) {
      const hours = time.split(':')[0];
      const minutes = time.split(':')[1];
      this.selectedHours = Number(hours);
      this.selectedMinutes = Number(minutes);
      this.$emit('update:modelValue', this.getRuntimeDate);
    },
    toggleShowCalendar() {
      this.showCalendar = !this.showCalendar;
      this.showRuntime = false;
    },
    toggleShowRuntime() {
      this.showRuntime = !this.showRuntime;
      this.showCalendar = false;
    },
  },
  mounted() {
    this.selectedHours = new Date(this.selectedDate).getHours();
    this.selectedMinutes = new Date(this.selectedDate).getMinutes();
  },
};
</script>
